import React from "react";
import { Box, Typography } from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import GradientCard from "../gradients/GradientCard";

const MobileDraggablePatch = ({ patch, morePatches }) => {
  const dragValue = React.useMemo(() => {
    return patch ? (
      <img
        loading="lazy"
        className="draggable"
        src={patch?.src}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
        }}
        data-patch={JSON.stringify(patch)}
        draggable={false}
      />
    ) : (
      <AddRoundedIcon style={{ color: "#E8408B", fontSize: "32px" }} />
    );
  }, [patch]);

  const handelMorePatches = React.useCallback(() => {
    if (!patch) {
      morePatches(true);
    }
  }, [patch]);

  return (
    <Box sx={{ width: "90px", paddingTop: "12px" }}>
      <Typography
        align="center"
        variant="h4"
        sx={{
          fontSize: "13px",
          margin: "0",
        }}
      >
        Active Patch
      </Typography>
      <GradientCard
        variant="square"
        onClick={handelMorePatches}
        sxMobile={{
          border: "none",
          borderRadius: "9px",
        }}
        sxInnerMobile={{
          borderRadius: "9px",
        }}
      >
        <Box
          sx={{
            flex: "1",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {dragValue}
        </Box>
      </GradientCard>
      <Typography align="center" variant="body2" sx={{ fontSize: "14px", marginTop: "8px" }}>
        {patch ? "Drag-n-drop" : "Select"}
      </Typography>
    </Box>
  );
};

export default MobileDraggablePatch;
